export default class IntegrationService {
  async GetAll() {
    return await window.$A.Api.get("/integration");
  }

  async Get(integrationKey) {
    return await window.$A.Api.get("/integration/" + integrationKey);
  }

  async SaveSettings(integrationKey, settings) {
    return await window.$A.Api.put(
      "/integration/" + integrationKey + "/settings",
      settings
    );
  }

  async Disconnect(integrationKey) {
    return await window.$A.Api.post(
      "/integration/" + integrationKey + "/disconnect"
    );
  }

  async GetWebHookHealth() {
    return await window.$A.Api.get("/integration/webhook-health");
  }

  async GetWebHook(webHookId) {
    return await window.$A.Api.get("/web-hook/" + webHookId);
  }

  async SaveWebHook(request) {
    return await window.$A.Api.post("/web-hook", request);
  }

  async UpdateWebHook(webHookId, request) {
    return await window.$A.Api.patch("/web-hook/" + webHookId, request);
  }

  async DeleteWebHook(webHookId) {
    return await window.$A.Api.delete("/web-hook/" + webHookId);
  }
}
